module.exports = __webpack_public_path__ + "img/6.314f0235.svg";